import { render, staticRenderFns } from "./externalContactsInput.vue?vue&type=template&id=5a367458&scoped=true&"
import script from "./externalContactsInput.vue?vue&type=script&lang=ts&"
export * from "./externalContactsInput.vue?vue&type=script&lang=ts&"
import style0 from "./externalContactsInput.vue?vue&type=style&index=0&id=5a367458&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a367458",
  null
  
)

export default component.exports